import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"u0jrN","textWrapNowrap":"fcJ5G","alignRight":"_7S25I","alignCenter":"gk-w9","sizeFullWidth":"tipdR","renderedInTable":"_5RAtJ","sizeOriginal":"IDIGU","sizeContent":"pqYey","sizeSmall":"gICdG","sizeSmallCenter":"cWeMD","flex":"DyKUB","atomic":"obhMM","anchor":"_4l-Fu","embed":"_9egUg","horizontalScrollbar":"KFkxl","pluginContainerMobile":"_2EuQR"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-7e031f0a.js.map
